import { render } from "./ResultList.vue?vue&type=template&id=10bed202&scoped=true"
import script from "./ResultList.vue?vue&type=script&lang=js"
export * from "./ResultList.vue?vue&type=script&lang=js"

import "./ResultList.vue?vue&type=style&index=0&id=10bed202&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bed202"]])

export default __exports__